import React from 'react';
import { BookOpenIcon, CheckIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { Reveal } from '../Reveal';
import { tomoIncludes, tomos } from '../../data/programa';
export function Tomos() {
  return <section id="programa" className="radial-navy border-b border-line py-[60px] lg:py-[100px]" data-id="element-214" data-mp="7xl0pqd78pjf">
      <div className="mx-auto max-w-content px-6 lg:px-10" data-id="element-215" data-mp="cvmlqgu6qyxj">
        <SectionHeading eyebrow="6 tomos completos · 420+ páginas" title={<>
              Tu jornada completa.{' '}
              <span className="text-gold" data-id="element-217" data-mp="3gdxs51yrjp50">Hora por hora.</span>
            </>} data-id="element-216" data-mp="3beb9ue42vipc" />

        <ol className="mx-auto mt-12 max-w-4xl divide-y divide-line border-y border-line" data-id="element-218" data-mp="3lbfxyjhhho8s">
          {tomos.map((tomo, index) => <Reveal key={tomo.number} delay={index * 0.03} as="li" data-id="element-219" data-mp="3qc3svg8u2p8a" data-mpi={index}>
              <div className="flex items-start gap-3 py-3" data-id="element-220" data-mp="10m0bg0pasloy">
                <BookOpenIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" strokeWidth={1.5} aria-hidden="true" data-id="element-221" data-mp="10nupcv25jdjj" />
                <div className="min-w-0" data-id="element-222" data-mp="15mo56u4wvgmv">
                  <h3 className="text-[14px] font-semibold leading-snug text-ice" data-id="element-223" data-mp="1hrphudh36vy6">
                    Tomo {Number(tomo.number)} — {tomo.title}{' '}
                    <span className="font-medium text-gold" data-id="element-224" data-mp="1crurqc54yae6">{tomo.window}</span>
                  </h3>
                  <p className="mt-0.5 text-[13px] leading-[1.5] text-cool" data-id="element-225" data-mp="18tx2j9bd7oas">
                    {tomo.description}
                  </p>
                </div>
              </div>
            </Reveal>)}
        </ol>

        <Reveal delay={0.08} className="mx-auto mt-12 max-w-4xl" data-id="element-226" data-mp="u366tq6nk52e">
          <div className="glass p-7" data-id="element-227" data-mp="u1v7c2k8pjh3">
            <h3 className="text-center text-[12px] font-medium uppercase tracking-[0.1em] text-gold" data-id="element-228" data-mp="p3tlxazcd82g">
              Cada tomo incluye
            </h3>
            <ul className="mt-6 grid gap-x-8 gap-y-2.5 sm:grid-cols-2" data-id="element-229" data-mp="l42myjznvlmu">
              {tomoIncludes.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-230" data-mp="g2vesjtlwkfn">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-231" data-mp="b425l3lcrfla" />
                  <span className="text-[14px] leading-[1.5] text-cool" data-id="element-232" data-mp="1gg9khrfn0kr">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </Reveal>
      </div>
    </section>;
}